import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FixedTooltip from './FixedTooltip';

const PORTAL_MOUNT_EL = window.document.body;

export default function FixedTooltipWrapper({ title, children, className }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    isVisible
      ? PORTAL_MOUNT_EL.classList.add('no-scroll')
      : PORTAL_MOUNT_EL.classList.remove('no-scroll');
  }, [isVisible]);

  function handleClick(e) {
    e.preventDefault();
    setIsVisible(!isVisible);
  }

  return (
    <div className={ classnames('FixedTooltipWrapper dib', className) }>
      <div
        role="button"
        tabIndex="0"
        onKeyPress={ null }
        onClick={ handleClick }
        className="pointer"
      >
        { children }
      </div>
      {
        createPortal(
          <>
            {
              isVisible &&
                <div
                  role="button"
                  tabIndex="-1"
                  onKeyPress={ null }
                  onClick={ () => setIsVisible(false) }
                  className="fixed bg-black-70 absolute--fill z-max"
                />
            }
            <div
              data-test-id="tooltip"
              className={
                classnames('FixedTooltipWrapper__tooltip z-max fixed transition bottom-0 left-0 right-0', {
                  'FixedTooltipWrapper__tooltip--hidden': !isVisible
                })
              }
            >
              <FixedTooltip
                title={ title }
                onCloseClick={ () => setIsVisible(false) }
              />
            </div>
          </>,
          PORTAL_MOUNT_EL
        )
      }
    </div>
  );
}

FixedTooltipWrapper.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

FixedTooltipWrapper.defaultProps = {
  className: null
};
